import React, { useState, useEffect, useRef } from 'react';
import { Timer, Volume2 } from 'lucide-react';

export const DropsTimer = ({ onComplete, label, patientName }) => {
  const [seconds, setSeconds] = useState(300); // 5 minutes
  const [isRunning, setIsRunning] = useState(false);
  const [isComplete, setIsComplete] = useState(false);
  const audioRef = useRef(null);

  useEffect(() => {
    if ('Notification' in window && Notification.permission === 'default') {
      Notification.requestPermission();
    }
  }, []);

  useEffect(() => {
    let interval;
    if (isRunning && seconds > 0) {
      interval = setInterval(() => {
        setSeconds(s => s - 1);
      }, 1000);
    } else if (seconds === 0 && isRunning) {
      setIsRunning(false);
      setIsComplete(true);
      if (audioRef.current) {
        audioRef.current.play();
      }
      sendDropsNotification(label, patientName);
      onComplete && onComplete();
    }
    return () => clearInterval(interval);
  }, [isRunning, seconds, onComplete, label, patientName]);

  const sendDropsNotification = (dropLabel, patient) => {
    if ('Notification' in window && Notification.permission === 'granted') {
      new Notification('⏰ Timer Gocce Completato!', {
        body: `${dropLabel || 'Gocce'} - ${patient || 'Paziente'}: Pronto per la seconda goccia!`,
        icon: '/favicon.ico',
        tag: 'drops-timer',
        requireInteraction: true
      });
    }
  };

  const startTimer = () => {
    setIsRunning(true);
    setIsComplete(false);
    setSeconds(300);
  };

  const formatTime = (s) => {
    const mins = Math.floor(s / 60);
    const secs = s % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  // Base64 beep sound
  const BEEP_SOUND = "data:audio/wav;base64,UklGRnoGAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQoGAACBhYqFbF1fdJivrJBhNjVgodDbq2EcBj+a2teleAEAJIrl/vmGZTlnhN/0uYVZQWKG4P3MiWU/YYPf/86KZT5fguH/z4tlP2CF4v/PimU/YIbj/9CJZT9hh+T/0IllP2CH4//QiWU/YIbi/8+KZT9ghuL/0IplP2GG4v/QiWU/YIbi/8+JZT9ghuL/z4plP2CG4v/PimU/YIbi/9CKZT9hhuP/0IllP2CG4v/PiWU/YIbi/8+KZT9ghuL/0IplP2GG4//QiWU/YIbi/9CKZT9hhuP/0IllP2GH5P/QiWU/YIfk/9CJZT9gh+P/0IllP2CG4v/PiWU/YIbi/8+JZT9ghuL/z4llP2CG4v/PiWU/YIbi/8+JZT9ghuL/z4llP2CG4v/OiWU/YIbi/8+JZT9ghuL/z4plP2CG4v/PiWU/YIbi/8+JZT9ghuL/z4llP2CG4v/PiWU=";

  return (
    <div className="flex items-center gap-2">
      <audio ref={audioRef} src={BEEP_SOUND} />
      
      {!isRunning && !isComplete && (
        <button
          onClick={startTimer}
          className="px-3 py-1 rounded-lg text-sm font-medium flex items-center gap-1"
          style={{ background: '#2A9FCB', color: 'white' }}
        >
          <Timer className="w-4 h-4" />
          {label || 'Gocce Messe'}
        </button>
      )}
      
      {isRunning && (
        <div className="flex items-center gap-2 px-3 py-1 rounded-lg bg-amber-100 text-amber-800">
          <Timer className="w-4 h-4 animate-pulse" />
          <span className="font-mono font-bold">{formatTime(seconds)}</span>
        </div>
      )}
      
      {isComplete && (
        <div className="flex items-center gap-2 px-3 py-1 rounded-lg bg-green-100 text-green-800 animate-pulse">
          <Volume2 className="w-4 h-4" />
          <span className="font-medium">Pronto per seconda goccia!</span>
          <button onClick={startTimer} className="ml-2 underline">Reset</button>
        </div>
      )}
    </div>
  );
};

export default DropsTimer;
